import { REPORT_TABLE_MODAL_CELL_NAME } from '../../ReportTableModal'

export const FILE_VIEWS_REPORT_TAB = 'views'

export const FILE_VIEWS_REPORT_UNKNOWN_USER_NAME_KEY =
  'Modal.FileViewsReportUnknownUserNameKey'

export const FILE_VIEWS_REPORT_COLUMNS_CONFIG = {
  [REPORT_TABLE_MODAL_CELL_NAME.building]: {
    index: 5,
    name: REPORT_TABLE_MODAL_CELL_NAME.building,
    ordering_field: null,
    title: 'Modal.FileViewsReportColumnAddressKey',
    visible: true,
    width: 415,
  },
  [REPORT_TABLE_MODAL_CELL_NAME.date]: {
    index: 1,
    name: REPORT_TABLE_MODAL_CELL_NAME.date,
    ordering_field: 'last_view_dt',
    title: 'Modal.FileViewsReportColumnDateKey',
    visible: true,
    width: 232,
  },
  [REPORT_TABLE_MODAL_CELL_NAME.email]: {
    index: 4,
    name: REPORT_TABLE_MODAL_CELL_NAME.email,
    ordering_field: null,
    title: 'Modal.FileViewsReportColumnEmailKey',
    visible: true,
    width: 240,
  },
  [REPORT_TABLE_MODAL_CELL_NAME.owner]: {
    index: 0,
    name: REPORT_TABLE_MODAL_CELL_NAME.owner,
    ordering_field: null,
    title: 'Modal.FileViewsReportColumnNameKey',
    visible: true,
    width: 240,
  },
  [REPORT_TABLE_MODAL_CELL_NAME.role]: {
    index: 3,
    name: REPORT_TABLE_MODAL_CELL_NAME.role,
    ordering_field: null,
    title: 'Modal.FileViewsReportColumnRoleKey',
    visible: true,
    width: 200,
  },
  [REPORT_TABLE_MODAL_CELL_NAME.status]: {
    index: 6,
    name: REPORT_TABLE_MODAL_CELL_NAME.status,
    ordering_field: null,
    title: 'Modal.FileViewsReportColumnStatusKey',
    visible: true,
    width: 176,
  },
  [REPORT_TABLE_MODAL_CELL_NAME.views]: {
    index: 2,
    name: REPORT_TABLE_MODAL_CELL_NAME.views,
    ordering_field: 'views_count',
    title: 'Modal.FileViewsReportColumnViewsKey',
    visible: true,
    width: 120,
  },
}
